import { Component, OnInit } from "@angular/core";
import { LockScreenService } from "./common/lock-screen.service";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "dppm-connect-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private lockScreenService: LockScreenService,
    public router: Router
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        (<any>window).Appcues && (<any>window).Appcues.page();
      }
    });
  }

  get lockScreen(): boolean {
    return this.lockScreenService.lockScreen;
  }
}
